import { type UseQueryResult, useQuery } from 'react-query';
import { ValuationService } from '@wealthlane/api-services/wealthlane-captable-service';

type GetValuationByIdResponse = Awaited<
  ReturnType<typeof ValuationService.getApiCapTableApiAppValuation>
>;

const useGetValuationById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string
): UseQueryResult<GetValuationByIdResponse | undefined, unknown> => {
  return useQuery(
    ['getValuationById', id],
    async () => {
      if (!id) {
        return undefined;
      }

      return await handleRequest(ValuationService.getApiCapTableApiAppValuation(id));
    },
    {
      enabled: !!id,
      refetchOnWindowFocus: false,
    }
  );
};

export default useGetValuationById;
